import { NavigationPosition, NavigationResolution } from '@unifyapps/defs/types/interface';
import { clsx } from 'clsx';
import { NavigationItemClassName } from '../../constants';
import { isHorizontalUpfrontFn } from '../../helpers';
import { navIconContainerVariants, navItemContainerVariants } from '../../styles';
import type { NavigationItemSlotPropsType } from '../../types';
import { NavigationItemLabelVariantEnum, NavigationItemSelectionVariantEnum } from '../../types';

interface GetActionNavItemContainerClassNamesParams {
  isActive: boolean;
  variant: 'lite' | 'rich';
  disabled?: boolean;
  navigationItem: NavigationItemSlotPropsType['navigationItem'];
}

function getActionNavItemContainerClassNames({
  isActive,
  variant,
  disabled,
  navigationItem,
}: GetActionNavItemContainerClassNamesParams) {
  const {
    labelVariant,
    position = NavigationPosition.Start,
    resolution,
    selectionVariant,
    alignment,
    direction,
    navItemBorderRadiusClassName,
  } = navigationItem ?? {};

  const isHorizontalUpfront = isHorizontalUpfrontFn(labelVariant, selectionVariant, direction);

  const navIconContainerClassName = navIconContainerVariants({
    labelVariant,
    selectionVariant,
    position,
    active: isActive,
    variant,
    resolution,
  });

  const isClickOnIconContainer =
    variant === 'rich' &&
    selectionVariant === NavigationItemSelectionVariantEnum.Solid &&
    labelVariant !== NavigationItemLabelVariantEnum.Expandable;

  const isSolid = selectionVariant === NavigationItemSelectionVariantEnum.Solid;
  let iconStateClassName: string;
  if (isActive) {
    iconStateClassName = isSolid ? 'ua-side-nav-item-active-solid' : 'ua-side-nav-item-active';
  } else {
    iconStateClassName = isSolid
      ? 'ua-side-nav-item-active-false-solid'
      : 'ua-side-nav-item-active-false';
  }

  const containerClassName = navItemContainerVariants({
    className: clsx(
      NavigationItemClassName[position],
      navItemBorderRadiusClassName,
      resolution === NavigationResolution.XL && !disabled ? 'cursor-pointer' : '',
      { 'items-center justify-center': position === NavigationPosition.Top },
      { '!pointer-events-none': disabled },
    ),
    variant,
    position,
    selectionVariant,
    labelVariant,
    direction,
    alignment,
    active: isActive,
    isHorizontalUpfront,
  });

  return {
    navIconContainerClassName,
    iconStateClassName,
    containerClassName,
    isClickOnIconContainer,
  };
}

export { getActionNavItemContainerClassNames };
